module.exports = function() {
  return new Worker("/" + "1a4755dc9c18ccf4ca70.worker.js");
};